const RESOURCES_CACHE_TIME = 60 * 60 * 1000; // 1 hour

export const authenticationApiFactory = ({ callGetApi, queryClient, callPostApi }) => ({
    getTokenDetails: () => callGetApi('/authentication/token-details?t=' + Date.now()),
    generateProfiledToken: ({ accountId, profile }) =>
        queryClient.fetchQuery(
            ['profiled-token', accountId],
            () => callPostApi(`/authentication/oauth/profiled-token/${accountId}`, { profile }),
            {
                staleTime: RESOURCES_CACHE_TIME,
                cacheTime: RESOURCES_CACHE_TIME,
            }
        ),
});
